module.exports = __webpack_public_path__ + "static/program-4535a35389b78bf6b9927d0bc774fb63.pdf";